import React from "react";

import Tooltip from "antd/es/tooltip";

import { Group } from "@mapmycustomers/shared/types/entity";

import EntityTag from "@app/component/EntityTag";
import { RegistryProps } from "@app/component/FieldGrid/utils/ComponentRegistry";

const GroupField = ({ entity, field }: RegistryProps) => {
  const groups = (field.getValueFor(entity) as Group[]) ?? [];

  return (
    <div>
      <Tooltip title={field.getFormattedValueFor(entity)}>
        {groups.map((group) => (
          <EntityTag entity={group} key={group.id} />
        ))}
      </Tooltip>
    </div>
  );
};

export default GroupField;
